import { connect } from 'react-redux';
import * as Actions from '../../../../../services/redux/deliveryNotes/actions';
import PropTypes from '../../../../../utils/propTypes';
import TraceabilityTable from './components/TraceabilityTable';
import { useEffect, useState } from 'react';
import ViewModal from './components/ViewModal';
import EditModal from './components/EditModal';
import { getElements } from '../../../../../services/api/elements';

const CustomTraceabilityList = ({ normative }) => {
  const [itemToView, setItemToView] = useState();
  const [itemToEdit, setItemToEdit] = useState();
  const [structuralElements, setStructuralElements] = useState();

  useEffect(() => {
    const getStructuralElements = async () => {
      const { data } = await getElements();
      if (data?.data) {
        setStructuralElements(data.data);
      }
    };

    if (normative === 'coe') {
      getStructuralElements();
    } else {
      setStructuralElements([
        { structural_element: 'MACIZOS', id: 1 },
        { structural_element: 'COMPRESIÓN', id: 2 },
        { structural_element: 'FLEXIÓN', id: 3 },
      ]);
    }
  }, [normative]);

  return (
    <>
      <TraceabilityTable
        onViewClick={setItemToView}
        onEditClick={setItemToEdit}
        normative={normative}
        structuralElements={structuralElements}
      />
      <ViewModal
        item={itemToView}
        onClose={() => setItemToView(undefined)}
        normative={normative}
      />
      <EditModal
        item={itemToEdit}
        onClose={() => setItemToEdit(undefined)}
        normative={normative}
        structuralElements={structuralElements}
      />
    </>
  );
};

CustomTraceabilityList.propTypes = {
  getDeliveryNotes: PropTypes.func.isRequired,
  cleanReducer: PropTypes.func.isRequired,
  normative: PropTypes.oneOf(['coe', 'ehe']).isRequired,
};

export default connect(() => ({}), {
  getDeliveryNotes: Actions.getDeliveryNotes,
  cleanReducer: Actions.initReducer,
})(CustomTraceabilityList);
